export default __webpack_public_path__ + "static/media/sign_up_middle_up2.f2416323.png";